<template>
	<transition 
			appear
			:appear-active-class="$_bnrLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start"
				no-gutters>
			<v-col>
				<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
					<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
						<v-row	:key="contentKey">
							<v-col>
								<v-banner
										class="customVBanner"

										:color="$_bnrLyt_styleBannerColor"
										:dark="$_bnrLyt_styleBannerDark"
										:elevation="$_bnrLyt_styleBannerElevation"
										:icon-color="$_bnrLyt_styleBannerIconColor"
										:light="$_bnrLyt_styleBannerLight"
										:outlined="$_bnrLyt_styleBannerOutlined"
										:rounded="$_bnrLyt_styleBannerRounded"
										:shaped="$_bnrLyt_styleBannerShaped"
										:single-line="$_bnrLyt_styleBannerSingleLine"
										:tile="$_bnrLyt_styleBannerTile"
										
										:icon="$_bnrLyt_styleContentIcon(contentVals)">
									<v-row>
										<v-col>
											<template v-if="contentVals.title">
												<v-row>
													<v-col>
														<span	class="title"
																v-html="$_bnrLyt_langContentTitle(contentVals)" />
													</v-col>
												</v-row>
												<v-divider/>
											</template>
											<template v-if="!isFalse($_bnrLyt_langContentText(contentVals))">
												<v-row>
													<v-col>
														<span	class="body-2 markdown"
																v-html="marked($_bnrLyt_langContentText(contentVals))" />
													</v-col>
												</v-row>
											</template>
										</v-col>
										<template v-if="isObject(contentVals.actionButtons)">
											<v-col cols="auto">
												<v-row class="row_" align="center">
													<v-col>
														<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
															<v-row :key="actionButtonKey">
																<v-col class="py-2">
																	<v-btn	class="customVBtn"
																			:block="$_bnrLyt_styleActionButtonBlock"
																			:color="$_bnrLyt_styleActionButtonColor"
																			:dark="$_bnrLyt_styleActionButtonDark"
																			:depressed="$_bnrLyt_styleActionButtonDepressed"
																			:elevation="$_bnrLyt_styleActionButtonElevation"
																			:large="$_bnrLyt_styleActionButtonLarge"
																			:light="$_bnrLyt_styleActionButtonLight"
																			:outlined="$_bnrLyt_styleActionButtonOutlined"
																			:rounded="$_bnrLyt_styleActionButtonRounded"
																			:small="$_bnrLyt_styleActionButtonSmall"
																			:text="$_bnrLyt_styleActionButtonFlat"
																			@click="openLink(actionButtonVals.link)"
																			v-text="$_bnrLyt_langActionButtonTitle(actionButtonVals)" />
																</v-col>
															</v-row>
														</template>
													</v-col>
												</v-row>
											</v-col>
										</template>
									</v-row>
								</v-banner>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'BannerLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				colors_: {}
			}
		},
		computed: {
			// state
			$_bnrLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang 
			// (content)
			$_bnrLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_bnrLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_bnrLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_bnrLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_bnrLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_bnrLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_bnrLyt_styleBanner() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'banner')
			},
			$_bnrLyt_styleBannerColor() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.color)
			},
			$_bnrLyt_styleBannerDark() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.dark)
			},
			$_bnrLyt_styleBannerElevation() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.elevation)
			},
			$_bnrLyt_styleBannerFlat() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.flat)
			},
			$_bnrLyt_styleBannerHover() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.hover)
			},
			$_bnrLyt_styleBannerIconColor() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.iconColor)
			},
			$_bnrLyt_styleBannerLight() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.light)
			},
			$_bnrLyt_styleBannerOutlined() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.outlined)
			},
			$_bnrLyt_styleBannerRounded() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.rounded)
			},
			$_bnrLyt_styleBannerShaped() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.shaped)
			},
			$_bnrLyt_styleBannerSingleLine() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.singleLine)
			},
			$_bnrLyt_styleBannerTile() {
				const self_ = this;
				const banner_ = self_.$_bnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.tile)
			},
			$_bnrLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_bnrLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_bnrLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_bnrLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_bnrLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_bnrLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_bnrLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_bnrLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_bnrLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_bnrLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_bnrLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_bnrLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_bnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_bnrLyt_styleContentIcon() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.icon;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getStylesVal(contentVal_)
				}
			}
		},
		methods: {
			$_bnrLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor()
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.cardActions_ {
		padding-bottom: 16px;
	}
	.row_ {
		height: 100%;
	}
</style>
